import thumb from '../../../assets/images/notes/thumb.png';
import full01 from '../../../assets/images/notes/full01.png';
import full02 from '../../../assets/images/notes/full02.png';
import full03 from '../../../assets/images/notes/full03.png';
import full04 from '../../../assets/images/notes/full04.png';
import full05 from '../../../assets/images/notes/full05.png';
import full06 from '../../../assets/images/notes/full06.png';
import full07 from '../../../assets/images/notes/full07.png';
import full08 from '../../../assets/images/notes/full08.png';

const notesData = {
  name: 'Notes App',
  description: 'A web application used to create, save, edit and delete notes.',
  skills: ['HTML5', 'CSS3', 'JavaScript'],
  sources: [
    { caption: 'Home | Notes App', source: full01 },
    { caption: 'Saved Notes | Notes App', source: full02 },
    { caption: 'Saved Notes | Notes App', source: full03 },
    { caption: 'Add New Note | Notes App', source: full04 },
    { caption: 'Saved Notes | Notes App', source: full05 },
    { caption: 'Edit Note | Notes App', source: full06 },
    { caption: 'Add New Note | Notes App', source: full07 },
    { caption: 'Saved Notes | Notes App', source: full08 },
  ],
  thumbnail: thumb,
  repoUrl: 'https://github.com/justsolomon/notes-app',
  liveUrl: 'https://justsolomon.github.io/notes-app',
};

export default notesData;
